module.exports = __webpack_public_path__ + "components/media-kit/static/icon-twitter-443f0751bce65296f9a2bcd05cec490e.svg";